import Nullstack from 'nullstack';
export default function IconTriangles({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-triangles",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9.974 21h8.052a0.975 .975 0 0 0 .81 -1.517l-4.025 -6.048a0.973 .973 0 0 0 -1.622 0l-4.025 6.048a0.977 .977 0 0 0 .81 1.517z"
  }), "   ", Nullstack.element("path", {
    d: "M4.98 16h14.04c.542 0 .98 -.443 .98 -.989a0.995 .995 0 0 0 -.156 -.534l-7.02 -11.023a0.974 .974 0 0 0 -1.648 0l-7.02 11.023a0.994 .994 0 0 0 .294 1.366a0.973 .973 0 0 0 .53 .157z"
  }), " ");
}